export interface LosLoginModel {
    grant_type: string;
    username: string;
    password: string;
    client_id: string;
    url: string;
}